module.exports = __webpack_public_path__ + "static/Arvo-Regular-d1a76d352f9be6b75c95b1f33b378070.ttf";